import * as yup from 'yup'

import { Signature } from '../../entity'

export const signature = yup.object<Signature>({
  content: yup.string().required(),
  date: yup.string().required(),
})
